import { trans } from '../functions';

export function showMoreAppointmentsEvent() {

	$('#showMoreAppointments').on('click', function(event) {
		event.preventDefault();

		var $button = $(this);

		var showen = $button.data('showen');

		if (showen == 'yes') {

			$('.schedulesContainer li.extraAppointment').hide();

			$button.text(trans('show_more_appointments')).data('showen', 'no');

		} else {

			$('.schedulesContainer li.extraAppointment').show();

			$button.text(trans('hide_extra_appointments')).data('showen', 'yes');
		}
	});
}
